import { useEffect, useState } from 'react';
import Layout from "../components/Layout";
import MySpinner from '../components/MySpinner';
import { useAuth } from '../auth/AuthContext';
import SupportButton from '../components/EmpLeaderComponents/SupportButton';
import { getMyLeaderPositionsAsync, getMySubordinatesAsync } from '../services/leaderService';

// Read-only leader view: the caller's positions and the subordinates reporting to each.
// (Subordinate management — assign / deactivate / update — was removed in V2.)
const EmpPositionManagement = () => {
  const [loading, setLoading] = useState(true);
  const [positions, setPositions] = useState([]);
  const [subordinateGroups, setSubordinateGroups] = useState([]);
  const { userInfo } = useAuth();

  const loadInitialData = async () => {
    setLoading(true);
    try {
      const [pos, subs] = await Promise.all([
        getMyLeaderPositionsAsync(),
        getMySubordinatesAsync(),
      ]);
      setPositions(pos || []);
      setSubordinateGroups(subs || []);
    } catch (e) {
      // leave lists empty on error
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadInitialData();
  }, []);

  if (loading) {
    return (
      <Layout>
        <MySpinner className="primary-color" />
      </Layout>
    );
  }

  if (!positions.length) {
    return (
      <Layout>
        <div className="text-center py-5">
          <h4 className="text-muted">ليس لديك أي منصب قيادي</h4>
        </div>
        <SupportButton userEmail={userInfo?.empEmail} />
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="mb-4 text-center">
        <h1 className="fw-semibold pb-2">عرض المناصب والمرؤوسين</h1>
      </div>

      {/* My positions */}
      <div className="p-3 container" style={{ maxWidth: '95%' }}>
        <h5 className="fw-bold mb-3">مناصبي</h5>
        <div className="d-flex flex-wrap gap-2">
          {positions.map((p) => (
            <span key={p.employeePositionId} className="badge primary-bg p-2">
              {p.positionTitle} - {p.departmentName}
            </span>
          ))}
        </div>
      </div>

      {/* Subordinates grouped by position */}
      <div className="p-3 container" style={{ maxWidth: '95%' }}>
        <h5 className="fw-bold mb-3">المرؤوسون</h5>
        {subordinateGroups.length === 0 ? (
          <div className="text-center text-muted py-3">لا يوجد مرؤوسون</div>
        ) : (
          subordinateGroups.map((group) => (
            <div key={group.superiorEmployeePositionId} className="mb-4 shadow-sm rounded p-3">
              <h6 className="fw-bold mb-3">
                {group.positionTitle} - {group.departmentName}
              </h6>
              <div className="table-responsive">
                <table className="table table-striped align-middle text-center mb-0">
                  <thead>
                    <tr>
                      <th>الاسم</th>
                      <th>المنصب</th>
                      <th>القسم</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(group.subordinates || []).map((s) => (
                      <tr key={s.employeePositionId}>
                        <td>{s.name}</td>
                        <td>{s.positionTitle}</td>
                        <td>{s.departmentName}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ))
        )}
      </div>

      <SupportButton userEmail={userInfo?.empEmail} />
    </Layout>
  );
};

export default EmpPositionManagement;
